<template>
    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <Head :title="$t('taxRates.new')" />
        <page-title :title="$t('taxRates.new')"></page-title>
    </div>

    <jet-form-section @submitted="createRate()">
        <template #form>
            <!-- Card Offer-->
            <form-card
                :title="$t('taxRates.title')"
                :description="$t('taxRates.description')"
            >
                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{
                        $t("taxRates.name")
                    }} <RequiredMark /></label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        v-model="form.name"
                        :placeholder="$t('taxRates.nameDesc')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        autofocus
                    />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="number" class="block text-sm font-medium text-gray-700">{{
                        $t("taxRates.value")
                    }} <RequiredMark /></label>
                    <input
                        step="0.01"
                        type="number"
                        name="value"
                        id="value"
                        v-model="form.value"
                        :placeholder="$t('taxRates.valueDesc')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                    />
                    <jet-input-error :message="form.errors.value" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label
                        class="flex items-center space-x-2 text-sm font-medium text-gray-700"
                        for="isDefault"
                    >
                        <input
                            id="isDefault"
                            name="isDefault"
                            v-model="form.isDefault"
                            type="checkbox"
                            class="border-gray-300 rounded"
                        />
                        <span>{{ $t("taxRates.isDefault") }}</span>
                    </label>
                    <jet-input-error :message="form.errors.isDefault" class="mt-2" />
                </div>
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import { Head } from "@inertiajs/inertia-vue3";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: [""],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        Head,
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark,
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        createRate() {
            this.form.post(this.route("advisors.taxRates.store"), {
                preserveScroll: true,
                onSuccess: () =>
                    this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "taxRates.created",
                    }),
            });
        },
    },
    setup(props) {
        const form = useForm({
            name: null,
            value: null,
            isDefault: false,
        });

        return { form };
    },
});
</script>

<style scoped></style>
